import React, { ReactNode } from 'react'
import { CreatePendencyFormValues } from '..'
import { useFormikContext } from 'formik'
import HeadingNew from 'presentation/shared/components/HeadingNew'
import * as S from './styles'

type CardMessagePreviewProps = {
  children: ReactNode
}

const CardMessagePreview = ({ children }: CardMessagePreviewProps) => {
  const { isValid } = useFormikContext<CreatePendencyFormValues>()

  return (
    <S.CardMessagePreviewWrapper>
      <HeadingNew
        color={isValid ? 'primary600' : 'neutral800'}
        size="xsmall"
        weight="bold"
        lineHeight="medium"
      >
        Veja uma prévia da pendência que será enviada:
      </HeadingNew>
      <S.CardMessagePreviewContent isValid={isValid}>
        {children}
      </S.CardMessagePreviewContent>
    </S.CardMessagePreviewWrapper>
  )
}

export default CardMessagePreview
